import React from 'react';
import { Lock } from 'lucide-react';

const LoginForm = ({ password, setPassword, handleLogin, loading }) => (
  <div className="w-full max-w-md mx-auto px-6 py-20 animate-in fade-in duration-500 text-center">
    <div className="bg-primary/10 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6 text-primary">
      <Lock size={24} />
    </div>
    <h2 className="text-2xl font-bold mb-6">Admin Access Required</h2>
    <form onSubmit={handleLogin} className="space-y-4">
      <input
        type="password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        placeholder="Enter admin password"
        className="w-full bg-background border border-input p-4 rounded-lg focus:ring-2 focus:ring-accent focus:outline-none"
      />
      <button 
        type="submit" 
        disabled={loading}
        className="w-full bg-accent text-accent-foreground font-bold py-4 rounded-lg hover:opacity-90 transition-opacity"
      >
        {loading ? 'Verifying...' : 'Login'}
      </button>
    </form>
  </div>
);

export default LoginForm;